import React, { Component } from 'react';
import { useMsal } from '@azure/msal-react';

class SignOutButtonClass extends Component {
  signOutClickHandler = () => {
    const { msalInstance } = this.props;
    const logoutRequest = {
      account: msalInstance.accounts[0],
      postLogoutRedirectUri: '/',
    };
    msalInstance.instance.logoutRedirect(logoutRequest);
  };

  render() {
    return (
      <button onClick={this.signOutClickHandler}>
        Sign Out
      </button>
    );
  }
}

function SignOutButtonWrapper() {
  const msalInstance = useMsal();
  return <SignOutButtonClass msalInstance={msalInstance} />;
}

export default SignOutButtonWrapper;
